module.exports = __webpack_public_path__ + "img/dice-1-fill.0d15cf9a.svg";